import { IconButton, Link, Theme, Typography, styled } from '@mui/material';

export const UploadedFileListItemText = styled(Typography)({
	maxWidth: '40%',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const UploadedFileListItemLink = styled(Link)({
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const UploadedFileListItemWrap = styled('li')({
	display: 'flex',
	flexDirection: 'column',
	borderRadius: '5px',
	background: '#F2F2F2',
	padding: '12px',
	gap: '12px',
	position: 'relative',
	transition: 'all .3s',
});

export const UploadedFileListItemCloseButton = styled(IconButton, {
	shouldForwardProp: (prop) => prop !== 'isError',
})(({ theme, isError }: { theme: Theme; isError: boolean }) => ({
	borderRadius: '50%',
	background: isError ? '#FF0000' : theme.palette.primary.main,
	position: 'absolute',
	top: '-10px',
	right: '0px',
	width: '24px',
	height: '24px',
	color: '#FFF',
	transition: 'all .3s',

	'&:hover': {
		backgroundColor: isError ? '#c70000' : theme.palette.primary.dark,
	},
}));
